import React from "react";
import SnackbarContent from "@material-ui/core/SnackbarContent";

import ActionButton from "../Buttons/ActionButton";

const ActionSnackbar = ({ buttonText, onConfirm, ...params }) => (
  <SnackbarContent
    {...params}
    action={<ActionButton onClick={onConfirm}>{buttonText}</ActionButton>}
  />
);

export default ActionSnackbar;
